import React from 'react';
import PropTypes from 'prop-types';
import layouts from '../layouts';

export const settings = {
  minTeases: 2,
  maxTeases: 4,
};

// eslint-disable-next-line react/prefer-stateless-function
class TeaseLayout extends React.Component {
  static propTypes = {
    layoutVariation: PropTypes.number,
    render: PropTypes.func,
  };

  static defaultProps = {
    layoutVariation: 0,
    render: () => null,
  };

  render() {
    const { layoutVariation: variation, render } = this.props;
    const { minTeases, maxTeases } = settings;

    // Check that number of variations is between min and max
    if (!variation || !(variation >= minTeases && variation <= maxTeases)) {
      return null;
    }

    return (
      <div className={`cs-layout cs-layout--${variation}-teases`} data-test="cs-layout">
        {render(layouts[variation])}
      </div>
    );
  }
}

export default TeaseLayout;
